import { motion } from "framer-motion";
import { CONTACT } from "@/data/site";

const WhatsAppIcon = (props) => (
  <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M17.5 14.4c-.3-.1-1.8-.9-2-1-.3-.1-.5-.1-.7.1-.2.3-.8 1-.9 1.2-.2.2-.3.2-.6.1-.3-.1-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6l.4-.5c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.1.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.2-.3-.3-.6-.4zM12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2c-1.5 0-3-.4-4.3-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2z" />
  </svg>
);

export const WhatsAppButton = () => (
  <motion.a
    href={CONTACT.whatsapp}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={`Chat on WhatsApp, ${CONTACT.phoneDisplay}`}
    data-testid="whatsapp-float-btn"
    initial={{ opacity: 0, y: 24 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 1.2, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    className="group fixed bottom-6 right-6 z-40 flex items-center gap-3 rounded-full bg-[#161614] text-[#FBFBF9] pl-4 pr-5 py-3 shadow-[0_12px_40px_-12px_rgba(0,0,0,.5)] hover:bg-[#25D366] hover:text-[#0b1a12] transition-colors duration-300"
  >
    <span className="relative flex">
      <span aria-hidden="true" className="wa-pulse absolute inset-0 rounded-full" />
      <WhatsAppIcon />
      <span className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-[#25D366] group-hover:bg-[#0b1a12] ring-2 ring-[#161614] group-hover:ring-[#25D366] transition-colors duration-300" />
    </span>
    <span className="hidden sm:flex flex-col leading-tight">
      <span className="font-mono text-[10px] uppercase tracking-[0.2em] opacity-70">WhatsApp</span>
      <span className="text-sm">{CONTACT.phoneDisplay}</span>
    </span>
  </motion.a>
);
